export const usernameUpdateRequest = {
  usernameUpdateRequests: "Username Update Requests",
  from: "From",
  to: "To",
  advanceFilter: "Advance Filter",
  userId: "User ID",
  currentUsername: "Current Username",
  requestedUsername: "Requested Username",
  cancel: "Cancel",
  filter: "Filter",
  requestedBy: "REQUESTED BY",
  requestedDate: "REQUESTED DATE",
  approve: "Approve",
  reject: "Reject",
  newUsername: "New Username",
  close: "Close",
};
